export const SCOPE_SMART_ADVISOR = 'SmartAdvisor';
export const SCOPE_FARM_PROFILE = 'FarmProfile';
export const SCOPE_PRODUCER_ADVISOR = 'ProducerAdvisor';
export const SCOPE_PRODUCER_POSITIONS = 'ProducerPositions';
export const SCOPE_PRODUCER_SCENARIOS = 'ProducerScenarios';
export const SCOPE_PRODUCER_BROADCAST = 'ProducerBroadcast';
